
    import { defineComponent } from 'vue'
    import Card from 'primevue/card'
    import KnFabButton from '@/components/UI/KnFabButton.vue'
    import Listbox from 'primevue/listbox'
    import workspaceFederationDatasetListDescriptor from './WorkspaceFederationDatasetListDescriptor.json'

    export default defineComponent({
        name: 'workspace-federation-definition-associations-list',
        components: { Card, KnFabButton, Listbox },
        props: { propAssociations: { type: Array } },
        emits: ['createAssociationClick'],
        data() {
            return {
                workspaceFederationDatasetListDescriptor,
                associations: [] as any[]
            }
        },
        watch: {
            propAssociations() {
                this.loadAssociations()
            }
        },
        created() {
            this.loadAssociations()
        },
        methods: {
            loadAssociations() {
                this.associations = this.propAssociations as any[]
            },
            createAssociation() {
                this.$emit('createAssociationClick')
            },
            deleteAssociationConfirm(association: any) {
                this.$confirm.require({
                    message: this.$t('common.toast.deleteMessage'),
                    header: this.$t('common.toast.deleteTitle'),
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => this.deleteAssociation(association)
                })
            },
            deleteAssociation(association: any) {
                const index = this.associations.findIndex((el: any) => el.relationship === association.relationship)
                if (index !== -1) this.associations.splice(index, 1)
            }
        }
    })
